import debug from "debug";
import {toCamelCase} from './strings';
const ZERO = 0;

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export default function debounce (func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

export function collectElementOptions(prefix, data) {
    return Object.keys(data)
        .map((key) => toCamelCase(key))
        .filter((key) => key.indexOf(prefix) >= ZERO)
        .reduce((result, source) => {
            const key = toCamelCase(source.replace(prefix, ''));
            result[key] = data[source];
            return result;
        }, {});
};



// WEBPACK FOOTER //
// ./project/client/src/core/lib/objects.js